/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
//Ember imports
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action } from '@ember/object';
import { isEmpty } from '@ember/utils';

// Internal imports

export default class ParentAppHomeLink extends Component {
  // customIcon specifies which custom-icons image should be shown (if any).
  @tracked customIcon = '';

  // image specifies the path to a specific image (i.e. user or school avatar).
  // Will be used instead of `customIcon` if both are specified.
  @tracked image = '';

  // icon specifies the name of a Phosphor icon used.
  icon = '';

  // iconSize modifies the Phospor icon's component size
  iconSize = '';

  // label specifies the text to be shown with the icon/image.
  label = '';

  // href specifies where the link should go.
  @tracked href = '';

  // imageClass specifies a custom CSS class to apply to the image.
  imageClass = '';

  // isLarge specifies the link's icon or image size.
  // large size is used for learners, and small for the rest of the links
  isLarge = false;

  // onClick specifies a custom onClick event
  onClick = null;

  // hasBadge controls whether the link has a bubble with an icon in it.
  // the badge has two states - default (green check) and warning (yellow with an exclamation mark)
  hasBadge = false;

  // if hasBadge is enabled, this controls when the warning badge gets shown instead of default
  showWarningBadge = true;

  warningBadgeTooltip = '';
  confirmationBadgeTooltip = '';

  // target determines the value for the link's `target` attribute.
  get target() {
    if (!isEmpty(this.href) && this.href.startsWith('http')) {
      return '_blank';
    }
    return '';
  }

  // imageSrc generates the `src` attribute for the image, based on custom icon/image.
  get imageSrc() {
    if (!isEmpty(this.image)) {
      return this.image;
    }
    if (!isEmpty(this.customIcon)) {
      return `/assets/images/icons/${this.customIcon}.png`;
    }
    return '/assets/images/empty.png';
  }

  @action
  handleClick() {
    this.onClick();
  }
}
